import React from "react"

import H1 from "../atoms/H1"
import Icon from "../../images/ampersand.svg"

import styles from "./Header.module.css"

const Header = () => (
  <header className={styles.container} role="banner">
    <H1>
      <span className={styles.title}>
        <span>Lashan James</span>
        <span>
          <Icon className={styles.icon} />
        </span>
        <span>Ezekiel Binion</span>
      </span>
    </H1>
  </header>
)

export default Header
